import 'css-chunk:src/app/containers/MemberDetail/components/MemberDetails/components/FieldRow/FieldRow.scss';export default {
  "row": "_row_1ldci_1",
  "actions": "_actions_1ldci_4",
  "edit": "_edit_1ldci_8",
  "value": "_value_1ldci_13",
  "copyBtn": "_copyBtn_1ldci_25"
};